import axios from "axios";
import PropTypes from "prop-types";
import React from "react";
import cacheManager from "../cacheManager";
import TriggerEvents from "../utils/trigger.events";
import "./vimeo.scss";
const triggerEvents = TriggerEvents();

const VIDEO_TYPE_SINGLE = "videoTypeSingle";
const VIDEO_TYPE_GROUPS = "videoTypeGroups";
const VIDEO_TYPE_ALBUM = "videoTypeAlbum";
const VIDEO_TYPE_USER = "videoTypeUser";
const VIDEO_TYPE_CHANNELS = "videoTypeChannels";
const VIDEO_TYPE_UNKNOWN = "videoTypeUnknown";

// shuffle array
function shuffle(a) {
  var j, x, i;
  for (i = a.length; i; i -= 1) {
    j = Math.floor(Math.random() * i);
    x = a[i - 1];
    a[i - 1] = a[j];
    a[j] = x;
  }
}

function cutLastSlash(originalUrl) {
  if (originalUrl.substr(originalUrl.length - 1) === "/") {
    originalUrl = originalUrl.substr(0, originalUrl.length - 1); // get the all characters except the last one
  }
  return originalUrl;
}

class VimeoPlayer extends React.Component {
  constructor(props) {
    super(props);
    this.playCount = 0;
    this.state = {
      isLoaded: false, // for hide the first spinner
      currentPlayIdx: 0,
      videos: []
    };
    this.isReady = false;
    this.delaySpinnerTimer = null;
    this.lastLoadPercent = 0; // tracking the loading status for checking the video failed loading

    // check this.props.maxPlayDurations for backwards compatability, if the old props not set then using the new one.
    this.maxPlayDurations =
      this.props.maxPlayDurations > 0
        ? this.props.maxPlayDurations
        : this.props.max_play_durations;
  }

  getVideoType(sourceUrl) {
    var videoType = VIDEO_TYPE_UNKNOWN;
    // if the url end with '/' the remove it before processing below
    sourceUrl = cutLastSlash(sourceUrl);

    if (sourceUrl.indexOf("/groups/") !== -1) {
      videoType = VIDEO_TYPE_GROUPS;
    } else if (sourceUrl.indexOf("/album/") !== -1) {
      videoType = VIDEO_TYPE_ALBUM;
    } else if (sourceUrl.indexOf("/channels/") !== -1) {
      videoType = VIDEO_TYPE_CHANNELS;
    } else if (
      sourceUrl.indexOf("https://vimeo.com/") !== -1 &&
      isNaN(
        parseInt(sourceUrl.split("https://vimeo.com/")[1].split("/")[0], 10)
      )
    ) {
      // https://vimeo.com/user13368490/videos
      // userId is mixed between characters and number !! videoId is always numberic
      videoType = VIDEO_TYPE_USER;
    } else if (
      sourceUrl.indexOf("https://vimeo.com/") !== -1 &&
      sourceUrl.split("https://vimeo.com/").length === 2
    ) {
      // https://vimeo.com/30698649
      videoType = VIDEO_TYPE_SINGLE;
    } else if (
      sourceUrl.indexOf("https://player.vimeo.com/video/") !== -1 &&
      sourceUrl.split("https://player.vimeo.com/video/").length === 2
    ) {
      videoType = VIDEO_TYPE_SINGLE;
    } else {
      videoType = VIDEO_TYPE_UNKNOWN;
    }
    return videoType;
  }

  fetchVideosRSS(sourceUrl) {
    var cacheKey = "vimeo_" + escape(sourceUrl);
    var videos = [];

    console.log("fetchVideosRSS: sourceUrl = " + sourceUrl);

    var targetVideoId = "";
    var baseURL = "https://vimeo.com/";

    if (this.videoType === VIDEO_TYPE_USER) {
      var userId = sourceUrl.split(baseURL)[1].split("/")[0];
      sourceUrl = baseURL + userId + "/videos/rss";
    } else if (this.videoType === VIDEO_TYPE_ALBUM) {
      var albumId = sourceUrl
        .split("https://vimeo.com/album/")[1]
        .split("/")[0];
      if (sourceUrl.indexOf("/video/") !== -1) {
        targetVideoId = sourceUrl.split(
          "https://vimeo.com/album/" + albumId + "/video/"
        )[1];
      }
      sourceUrl = "https://vimeo.com/album/" + albumId + "/rss";
    } else if (this.videoType === VIDEO_TYPE_GROUPS) {
      var groupsId = sourceUrl
        .split("https://vimeo.com/groups/")[1]
        .split("/")[0];
      if (sourceUrl.indexOf("/videos/") !== -1) {
        targetVideoId = sourceUrl.split(
          "https://vimeo.com/groups/" + groupsId + "/videos/"
        )[1];
      }
      baseURL = baseURL + "groups/" + groupsId + "/videos/";
      sourceUrl = "https://vimeo.com/groups/" + groupsId + "/videos/rss";
    } else if (this.videoType === VIDEO_TYPE_CHANNELS) {
      var channelsId = sourceUrl
        .split("https://vimeo.com/channels/")[1]
        .split("/")[0];
      if (sourceUrl.indexOf("/videos/") !== -1) {
        targetVideoId = sourceUrl.split(
          "https://vimeo.com/channels/" + channelsId + "/videos/"
        )[1];
      }
      baseURL = baseURL + "channels/" + channelsId + "/";
      sourceUrl = "https://vimeo.com/channels/" + channelsId + "/videos/rss";
    }

    console.log(
      "channelsId = " +
        channelsId +
        "   current play targetVideoId = " +
        targetVideoId
    );
    console.log("sourceUrl = " + sourceUrl + "     baseURL = " + baseURL);

    if (this.props.cacheMaxAge && Number(this.props.cacheMaxAge) > 0) {
      videos = cacheManager.cached(
        cacheKey,
        [],
        60 * Number(this.props.cacheMaxAge) * 1000
      ); // 1 hour cached // cached for 24 hour = 60 * 60 * 24 * 1000
    } else {
      videos = cacheManager.cached(cacheKey, [], 60 * 30 * 1); // default to 30 mins cached
    }

    var targetVideoIdx = 0;
    if (videos.length === 0) {
      const fetchUrl =
        process.env.REACT_APP_RSS_API_URL + "/feed?oembed=0&url=" + sourceUrl;

      axios
        .get(fetchUrl)
        .then(response => {
          console.log("screencloud-apps rss response = ", response);
          var result = response.data.posts;
          if (result.length > 0) {
            for (var i = 0; i < result.length; i++) {
              var link = this.replaceHTTPS(result[i].link);
              var videoPart = link.split(baseURL)[1];
              videos.push(videoPart);

              var videoId = link.split("/").pop();
              if (targetVideoId === videoId) {
                targetVideoIdx = i;
              }
            }

            console.log(
              "total videos = " +
                videos.length +
                "   target videoId = " +
                targetVideoIdx
            );
            cacheManager.cache(cacheKey, videos);
            if (this.props.shuffle === true || this.props.shuffle === "true") {
              // shuffle the video
              shuffle(videos);
            }

            this.setState({
              isLoaded: true,
              videos: videos,
              currentPlayIdx: targetVideoIdx
            });
          } else {
            // video not found
            console.log("result is zero !! skip video");
            console.log("sendFinishedEvent");

            this.props.onPlayEnded();
          }
        })
        .catch(function(response) {
          console.log("screencloud-apps rss error = ", response);
          console.log("sendFinishedEvent");
          this.props.onPlayEnded();
        });
    } else {
      console.log("Served CACHED feed");
      if (this.props.shuffle || this.props.shuffle === "true") {
        // shuffle the video
        shuffle(videos);
      }

      this.setState({
        isLoaded: true,
        videos: videos,
        currentPlayIdx: targetVideoIdx
      });
    }
  }

  // Helper function for sending a message to the VIMEO player
  post(action, value) {
    var data = {
      method: action
    };

    if (value || value === 0) {
      data.value = value;
    }

    var message = JSON.stringify(data);
    console.log("postMessage = ", message);
    this.player.contentWindow.postMessage(message, this.playerOrigin);
    console.log("this.player.contentWindow = ", this.player.contentWindow);
    console.log("this.playerOrigin = ", this.playerOrigin);
  }

  logStatus(msg) {
    this.status = msg;
    console.log("status: " + this.status);
  }

  clearMonitorPlay() {
    if (this.playAttempTimeout) {
      clearTimeout(this.playAttempTimeout);
      this.playAttempTimeout = null;
    }
  }

  monitorPlayAttempTimeout() {
    var playAttempLimitTime = 30 * 1000; // 30 seconds

    if (
      this.playAttempTimeout === null ||
      this.playAttempTimeout === undefined
    ) {
      this.playAttempTimeout = setTimeout(() => {
        if (this.retried === true) {
          // skip to next video or finish if nothing there
          console.warn("Vimeo: has already retried seek so call onFinish");
          this.post("pause");
          this.onFinish();
          this.retried = false;
        } else {
          this.retried = true;
          var seconds = 0.1;
          if (this.playProgressData && this.playProgressData.seconds) {
            seconds = this.playProgressData.seconds;
          }
          console.log("Retry !!! seek from current play seconds: " + seconds);
          seconds = Number(seconds) + 0.2; // seek ahead 0.5 second

          if (
            this.playProgressData &&
            this.playProgressData.duration &&
            seconds > this.playProgressData.duration
          ) {
            // reach the end of the clip
            this.onFinish();
            this.retried = false;
          } else {
            this.post("seek", seconds);
            this.clearMonitorPlay();
            this.monitorPlayAttempTimeout();
          }
        }
      }, playAttempLimitTime);
    } else {
      // refresh the monitoring
      this.clearMonitorPlay();
      this.monitorPlayAttempTimeout();
    }
  }

  hideSpinner() {
    if (this.spinner) {
      this.spinner.target.style.visibility = "hidden";
    }
    if (this.delaySpinnerTimer) {
      clearTimeout(this.delaySpinnerTimer);
      this.delaySpinnerTimer = null;
    }
  }

  showSpinner() {
    console.log("-showSpinner-");
    var lazySpinnerDelay = 3000; // 3 seconds

    // always check timer before start a new one
    if (this.delaySpinnerTimer) {
      clearTimeout(this.delaySpinnerTimer);
      this.delaySpinnerTimer = null;
    }

    if (this.delaySpinnerTimer === null) {
      this.delaySpinnerTimer = setTimeout(() => {
        // always clear itself after timer tick
        this.delaySpinnerTimer = null;

        if (this.spinner) {
          this.spinner.target.style.visibility = "visible";
        } else {
          var target = document.getElementById("spinner");
          if (target) {
            this.spinner = {}; // new Spinner(opts).spin(target)
            target.style.width = "30px"; // smaller than the first one
            target.style.height = "30px"; // smaller than the first one
            target.style.position = "absolute";
            target.style.top = "50%";
            target.style.left = "50%";
            this.spinner.target = target;
          }
        }
      }, lazySpinnerDelay);
    }
  }

  // ------- vimeo events

  onReady() {
    this.logStatus("ready");
    this.isReady = true;

    setTimeout(() => {
      this.post("addEventListener", "pause");
      this.post("addEventListener", "finish");
      this.post("addEventListener", "playProgress");
      this.post("addEventListener", "loadProgress");
    }, 50);

    setTimeout(() => {
      this.showSpinner(); // try showing spinner but if the playback start before spinner request success then the spinner will showup
      if (this.props.mute === true || this.props.mute === "true") {
        this.logStatus("mute = TRUE ");
        this.post("setVolume", 0);
      } else {
        this.logStatus("mute = FALSE ");
        this.post("setVolume", 1);
      }

      if (this.props.preload === true) {
        // disable autoplay during preload
        this.post("pause");
      } else {
        this.post("play"); // auto play when ready, to make sure it'll playing
        console.log("send play command !!");
      }
    }, 70);

    if (this.maxDurationTimeout) {
      clearTimeout(this.maxDurationTimeout);
      this.maxDurationTimeout = null;
    }

    console.log(
      "Vimeo: start maxDurationTimeout : " + this.maxPlayDurations + "mins"
    );
    this.maxDurationTimeout = setTimeout(() => {
      console.log(
        "Vimeo: maxDurationTimeout EXPIRED : " + this.maxPlayDurations + "mins"
      );
      this.post("pause");
      this.setState(
        {
          currentPlayIdx: this.state.videos.length - 1
        },
        () => {
          this.onFinish();
        }
      );
    }, this.maxPlayDurations * 60 * 1000); // in mins
  }

  onPause() {
    this.logStatus("paused");
  }

  onFinish() {
    this.hideSpinner();
    this.clearMonitorPlay();

    this.playCount++;
    this.logStatus(
      "finished: this.playCount = " +
        this.playCount +
        " / this.props.count = " +
        this.props.count
    );
    console.log(
      "Vimeo: this.state.currentPlayIdx = " +
        this.state.currentPlayIdx +
        " / (video length-1) = " +
        (this.state.videos.length - 1)
    );

    if (
      (this.props.count && Number(this.props.count) <= this.playCount) ||
      this.state.currentPlayIdx >= this.state.videos.length - 1
    ) {
      console.log("sendFinishedEvent");
      this.props.onPlayEnded();
    } else {
      this.setState({
        currentPlayIdx: this.state.currentPlayIdx + 1
      });
    }
  }

  onPlayProgress(data) {
    // console.log('play progress ', data)

    this.playProgressData = data;

    this.clearMonitorPlay();

    // playProgress = video is playing so keep hiding the spinner
    this.hideSpinner();

    // everytime it's playing hide the spinner
    if (data && data.percent !== 1 && !this.props.preload) {
      // once it's hidden then try to show up again after a few seconds,
      // so when playProgress is no contined then we showSpinnert
      // this.showSpinner()
      this.monitorPlayAttempTimeout();
    }

    // this.logStatus(data.seconds + 's played')
  }

  onLoadProgress(event) {
    // this.logStatus('loadProgress: ' + event.data.percent + '   duration: ' + event.data.seconds + '/' + event.data.duration)
    // console.log('event = ', event)

    // if loadProgress has no progress then attemp to show spinner (after 5 seconds)
    if (
      this.lastLoadPercent === event.data.percent &&
      this.lastLoadPercent !== 1 &&
      this.lastLoadSeconds === event.data.seconds
    ) {
      // todo:
      // loading not progress more, may be need some hack here to seek forward or backward a bit
      if (this.playProgressData && this.playProgressData.seconds) {
        var seconds = this.playProgressData.seconds;
        console.log("Prepare to Seek from current play seconds: " + seconds);
        seconds = Number(seconds) + 0.5; // seek ahead 0.5 second

        if (
          this.playProgressData &&
          this.playProgressData.duration &&
          seconds > this.playProgressData.duration
        ) {
          this.onFinish();
          this.retried = false;
        } else {
          this.post("seek", seconds);
        }
      }
    }
    this.lastLoadPercent = event.data.percent;
    this.lastLoadSeconds = event.data.seconds;
  }

  // Handle messages received from the player
  onMessageReceived(event) {
    // Handle messages from the vimeo player only
    if (!/^https?:\/\/player.vimeo.com/.test(event.origin)) {
      return false;
    }

    if (this.playerOrigin === "*") {
      this.playerOrigin = event.origin;
    }

    var data = JSON.parse(event.data);

    switch (data.event) {
      case "ready":
        this.onReady();
        break;

      case "playProgress":
        this.onPlayProgress(data.data);
        break;

      case "loadProgress":
        this.onLoadProgress(data);
        break;

      case "pause":
        this.onPause();
        break;

      case "finish":
        this.onFinish();
        break;
      default:
        break;
    }
  }

  // React Live cycle
  replaceHTTPS(url) {
    if (url.indexOf("http://") === 0) {
      url = url.replace("http://", "https://");
    }
    return url;
  }

  componentDidMount() {
    setTimeout(() => {
      if (this.spinner === undefined) {
        setTimeout(() => {
          var target = document.getElementById("spinner");

          if (target && !this.state.isLoaded) {
            this.spinner = {}; // new Spinner(opts).spin(target)
            target.style.width = "50px";
            target.style.height = "50px";
            target.style.position = "absolute";
            target.style.top = "50%";
            target.style.left = "50%";
            this.spinner.target = target;
            console.log("create spinner !");
          }
        }, 50);
      }

      this.playerOrigin = "*";
      this.status = "";

      if (this.vimeoIframe) {
        this.vimeoIframe.style.visibility = "hidden";
      }

      var targetURL = this.replaceHTTPS(this.props.url);
      targetURL = cutLastSlash(targetURL);

      this.videoType = this.getVideoType(targetURL);
      console.log("video url = " + targetURL + "    type = " + this.videoType);

      if (this.videoType === VIDEO_TYPE_SINGLE) {
        // URL scheme: https://vimeo.com/*
        // URL scheme: https://player.vimeo.com/video/*
        var videoId = "";
        if (targetURL.indexOf("https://vimeo.com/") !== -1) {
          videoId = targetURL.split("https://vimeo.com/")[1].split("/")[0];
        } else if (
          targetURL.indexOf("https://player.vimeo.com/video/") !== -1
        ) {
          videoId = targetURL
            .split("https://player.vimeo.com/video/")[1]
            .split("/")[0];
        } else {
          // failed !!, skip video
          this.onFinish();
          return;
        }
        console.log("videoId = " + videoId);
        this.setState({
          isLoaded: true,
          currentPlayIdx: 0,
          videos: [videoId]
        });
      } else if (this.videoType !== VIDEO_TYPE_UNKNOWN) {
        // the rest are album, channels, group
        this.fetchVideosRSS(targetURL);
      } else {
        // VIDEO_TYPE_UNKNOWN , skip video
        this.onFinish();
        return;
      }

      // Listen for messages from the player
      if (window.addEventListener) {
        window.addEventListener(
          "message",
          event => {
            this.onMessageReceived(event);
          },
          false
        );
      } else {
        window.attachEvent(
          "onmessage",
          event => {
            this.onMessageReceived(event);
          },
          false
        );
      }
    }, 50);
  }

  UNSAFE_componentWillUpdate(nextProps, nextState) {
    // invoked immediately before rendering with new props or state, not for initial 'render'
    // Use this as an opportunity to perform preparation before an update occurs.
    // You cannot use this.setState() in this method. If you need to update state in response to a prop change, use componentWillReceiveProps instead.
    console.log("componentWillUpdate nextProps.preload = ", nextProps.preload);
    if (this.props.preload !== nextProps.preload) {
      if (nextProps.preload === false && this.isReady === true) {
        this.post("play");
        this.clearMonitorPlay();
        this.monitorPlayAttempTimeout();
      }
    }
  }

  componentWillUnmount() {
    if (this.maxDurationTimeout) {
      clearTimeout(this.maxDurationTimeout);
      this.maxDurationTimeout = null;
    }

    if (this.playAttempTimeout) {
      clearTimeout(this.playAttempTimeout);
      this.playAttempTimeout = null;
    }

    if (this.delaySpinnerTimer) {
      clearTimeout(this.delaySpinnerTimer);
      this.delaySpinnerTimer = null;
    }
  }

  render() {
    var videoPath = "";

    if (this.state.isLoaded) {
      console.log("this.spinner = ", this.spinner);
      if (this.spinner) {
        this.spinner.target.style.visibility = "hidden";
      }

      if (this.player) {
        this.player.style.visibility = "visible";
        videoPath =
          "https://player.vimeo.com/video/" +
          this.state.videos[this.state.currentPlayIdx] +
          "?api=1&player_id=player1&autoplay=1&autopause=0&title=0&loop=0"; // &background=1&autoplay=1&loop=0&autopause=0
        // videoPath = 'https://player.vimeo.com/video/4578366?api=1&player_id=player1&autoplay=1&loop=0&automute=0&autopause=0'
      }
      if (this.props.preload === false) {
        this.monitorPlayAttempTimeout();
      }
    }

    var style = { width: "100%", height: "100%" };
    var debugStatus = "";

    var wrapperClassName = "";

    if (this.props.preload === true && this.state.isLoaded === true) {
      wrapperClassName = "preloadState";
      if (!this.isAppPreloaded) {
        this.isAppPreloaded = true;
        triggerEvents.sendAppStatusPreloaded({
          title: "Vimeo",
          url: this.props.url
        });
      }
    } else if (this.props.preload === false && this.state.isLoaded === true) {
      if (!this.isAppStarted) {
        this.isAppStarted = true;
        triggerEvents.sendAppStatusStarted({
          duration: -1 || "",
          title: "Vimeo",
          url: this.props.url
        });
      }
    }

    return (
      <div style={style} className={wrapperClassName}>
        <script src="https://f.vimeocdn.com/js/froogaloop2.min.js" />
        <span id="spinner" className="spinner" />
        {debugStatus}
        <iframe
          title="Vimeo"
          id="vimeoPlayer"
          ref={ele => (this.vimeoIframe = ele)}
          src={videoPath}
          width="100%"
          height="100%"
          frameBorder="0"
          webkitallowfullscreen
          mozallowfullscreen
          allowFullScreen
        />
      </div>
    );
  }
}

VimeoPlayer.propTypes = {
  url: PropTypes.string.isRequired,
  preload: PropTypes.bool,
  shuffle: PropTypes.bool,
  mute: PropTypes.bool,
  count: PropTypes.string,
  onPlayEnded: PropTypes.func,
  cacheMaxAge: PropTypes.string,
  maxPlayDurations: PropTypes.number,
  max_play_durations: PropTypes.number
};

VimeoPlayer.defaultProps = {
  url: "https://vimeo.com/76979871",
  maxPlayDurations: 0,
  max_play_durations: 60, // minutes
  shuffle: false,
  mute: false
};

export default VimeoPlayer;
